import {
  DeductibleOverridesFormValues,
  InsuranceFormValues,
  NewProviderFormValues,
  ProviderVisitFormValues,
} from '../../../models';
import {
  ContactsUserData,
  InsuranceUserDataType,
  ProductFrequenciesUserData,
  ProductItemDohUserData,
  ProductItemQuantityUserData,
} from './order-wizard-data.model';

export class LoadOrderWizard {
  static readonly type = '[Wizard] Load Order Wizard';
  constructor(public reorderId: number) {}
}

export class SetInsuranceUserData {
  static readonly type = '[Wizard] Update Insurance User Data';
  constructor(public insuranceType: InsuranceUserDataType, public insuranceData: InsuranceFormValues) {}
}

export class SetProductItemQuantitiesUserData {
  static readonly type = '[Wizard] Update Product Item Quantities User Data';
  constructor(public quantities: ProductItemQuantityUserData[]) {}
}

export class SetProductItemsDohUserData {
  static readonly type = '[Wizard] Update Product Days on Hand User Data';
  constructor(public dohValues: ProductItemDohUserData[], public isDohFormValid: boolean) {}
}

export class SetProductItemsOuDohUserData {
  static readonly type = '[Wizard] Update Product OU Days on Hand User Data';
  constructor(public doh: number) {}
}

export class SetProductFrequenciesUserData {
  static readonly type = '[Wizard] Update Product Frequencies User Data';
  constructor(public frequencies: ProductFrequenciesUserData) {}
}

export class SetProviderUserData {
  static readonly type = '[Wizard] Update Wizard Provider Step selectedProvider and providerVisitsForm';

  constructor(
    public providerStepFormValues: {
      selectedProviderId: number | null;
      providerVisitFormValues: ProviderVisitFormValues;
    }
  ) {}
}

export class SetNewProviderUserData {
  static readonly type = '[Wizard] Update Wizard Provider Step newProviderForm';
  constructor(public newProviderFormValues: NewProviderFormValues) {}
}

export class SetContactsUserData {
  static readonly type = '[Wizard] Update Wizard Contacts Step user data';
  constructor(public userData: ContactsUserData) {}
}

export class SetSelectedPaymentMethodUserData {
  static readonly type = '[Wizard] Update Wizard Billing Step selected payment method user data';
  constructor(public paymentMethodId: string) {}
}

export class SetDeductibleOverridesUserData {
  static readonly type = '[Wizard] Update Wizard Billing Step Deductible Overrides User Data';
  constructor(public deductibleOverridesFormValues: DeductibleOverridesFormValues) {}
}

export class ResetOrderWizardData {
  static readonly type = '[Wizard] Fully reset order wizard';
}

export class RefetchDosAndCopayIfNeeded {
  static readonly type = '[Wizard] Update DoS then Copay if Needed';
  constructor(public haveQuantitiesChanged: boolean) {}
}

export class RefetchCopayIfNeeded {
  static readonly type = '[Wizard] Update Copay if Needed';
  constructor(public previousTargetShipDate: string | null, public quantitiesUpdated: boolean = false) {}
}

export class UpdateCopayWithDeductibleOverrides {
  static readonly type = '[Wizard] Update Copay with Deductible Overrides';
}

export class ValidateProviderVisit {
  static readonly type = '[Wizard] Validate Provider Visit';

  constructor(
    public visitDate: string,
    public forLastVisit: boolean = true,
    public previousTargetShipDate: string | null
  ) {}
}

export class SetOrderConfirmed {
  static readonly type = '[Wizard] Set Order Confirmed';
  constructor(public isConfirmed: boolean) {}
}
